import { env } from '@/env';
import {
  browserStorageGetSessionItem,
  browserStorageRemoveSessionItem,
  browserStorageSetSessionItem,
} from '@/utils/browserStorage';

export const OAUTH_AUTHORIZE_RETURN_TO_KEY = 'oauthAuthorizeReturnTo';

function getFirstQueryValue(value) {
  return Array.isArray(value) ? value[0] : value;
}

function isTrustedOAuthAuthorizeUrl(value) {
  const returnTo = getFirstQueryValue(value);
  if (!returnTo || typeof returnTo !== 'string') {
    return false;
  }

  try {
    const targetUrl = new URL(returnTo);
    const trustedOrigins = new Set([
      new URL(env.authUrl).origin,
      'https://auth.dashhudson.com',
      'https://auth.dashsocial.com',
    ]);

    return trustedOrigins.has(targetUrl.origin) && targetUrl.pathname === '/oauth/authorize';
  } catch {
    return false;
  }
}

export function rememberOAuthAuthorizeReturnTo(returnTo) {
  const next = getFirstQueryValue(returnTo);
  if (isTrustedOAuthAuthorizeUrl(next)) {
    browserStorageSetSessionItem(OAUTH_AUTHORIZE_RETURN_TO_KEY, next);
  }
}

export function consumeOAuthAuthorizeReturnTo(returnTo) {
  const next = getFirstQueryValue(returnTo);
  if (isTrustedOAuthAuthorizeUrl(next)) {
    browserStorageRemoveSessionItem(OAUTH_AUTHORIZE_RETURN_TO_KEY);
    return next;
  }

  const storedNext = browserStorageGetSessionItem(OAUTH_AUTHORIZE_RETURN_TO_KEY);
  browserStorageRemoveSessionItem(OAUTH_AUTHORIZE_RETURN_TO_KEY);
  return isTrustedOAuthAuthorizeUrl(storedNext) ? storedNext : null;
}
